import { Text } from '@fable/components'
import { css, useTheme } from '@fable/theme'
import { useStats } from '../lib/ctx/stats'
import { StatsShareAsset } from './shared'
import { Screenshot, ScreenshotProvider } from 'components/screenshot'

const Content = () => {
  const { colors } = useTheme()
  const [options, isProfileView, isDesktop] = useStats((s) => [
    s.shareModalOptions,
    s.isProfileView,
    s.isDesktop,
  ])
  const isProfileOnMobile = !isDesktop && isProfileView

  return (
    <Screenshot
      imgStyles={css`
        border-radius: 8px;
        overflow: hidden;
        min-height: 0;
        flex-shrink: 0;
      `}
      width={options?.width}
      retry={options?.retry}
      delay={1000}
      footer={
        isProfileOnMobile ? (
          <Text
            className={css`
              margin-top: 8px;
              pointer-events: none;
            `}
            type="body"
            sizing="S"
            weight="500"
            color={colors.uiGraphite}
            align="center"
          >
            Tap and hold to download
          </Text>
        ) : null
      }
    >
      <StatsShareAsset
        className={options?.styles}
        backgroundColor={options?.backgroundColor}
        gradient={options?.gradient}
      >
        {options?.component}
      </StatsShareAsset>
    </Screenshot>
  )
}

export const StatsShareModalImage = () => (
  <ScreenshotProvider>
    <Content />
  </ScreenshotProvider>
)
